import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import DeleteComponent from "./Components/DeleteComponent";
import EditPasswordComponent from "./Components/EditPasswordComponent";

const AccountSecurity: React.FC = () => {
	const { t } = useTranslation();
	return (
		<div style={{ margin: "3rem 2rem", flexGrow: 1 }}>
			<Typography
				sx={{ color: "#545351", fontSize: "1.2rem", marginBottom: "1rem" }}
			>
				{t("account_security_settings.title")}
			</Typography>
			<div
				className="AccountSecurity__Container"
				style={{ border: "2px solid #E0E0E0", backgroundColor: "#FFFFFF" }}
			>
				<EditPasswordComponent translationObject={t} />
				<div style={{ border: "1px solid #E0E0E0" }} />
				<DeleteComponent translationObject={t} />
			</div>
		</div>
	);
};

export default AccountSecurity;
